export const SETTING_KEYS = {
	FLOW_ZOOM_LEVEL: 'agent-builder.view.flowZoomLevel',
	EXPLORER_AUTO_COLLAPSE: 'agent-builder.view.explorerAutoCollapse',
	SEARCH_BY_ID: 'agent-builder.view.searchById',
	ALWAYS_SHOW_SEARCH_BAR: 'agent-builder.view.alwaysShowSearchBar',
	SHOW_IDS_ON_NODES: 'agent-builder.view.showNodeIds',
	SHOW_IDS_IN_SIDE_SHEETS: 'agent-builder.view.showSideSheetIds',
	SHOW_IDS_ON_TABLES: 'agent-builder.view.showTableIds',
	SHOW_IDS_NEXT_TO_TITLES: 'agent-builder.view.showTitleIds',
	SHOW_IDS_IN_SESSION_VIEWER: 'agent-builder.view.showSessionViewerIds',
	SHOW_ELEMENT_DETAILS_IN_SELECTORS: 'agent-builder.view.showElementDetailsInSelectors',
	PREFIX_TOPICS_AND_FLOWS_WITH_ACTIVITY: 'agent-builder.view.prefixTopicsAndFlowsWithActivity',
	HIDE_DOCUMENTATION_LINKS: 'agent-builder.view.hideDocumentationLinks',
	DEMO_MODE: 'agent-builder.view.demoMode',
	ASSERTION_ERROR_DISPLAY: 'agent-builder.testing.assertionErrorDisplay',
	BATCH_SIZE_MODE: 'agent-builder.testing.batchSizeMode',
	BATCH_SIZE_VALUE: 'agent-builder.testing.batchSizeValue',
	SHOW_SESSION_ACTIVITY: 'session-viewer.view.showSessionActivity'
} as const
